export const getFormName = (form)=>{
    const formName = form.properties?.name;
    return formName ?? undefined;
};

//# sourceMappingURL=get-form-name.js.map